import { useNavigate } from 'react-router-dom';
import { useLang } from '../lib/lang';
import type { AuthUser } from '../lib/auth';
const C = {
  yellow: '#F7D000',
  black:  '#111827',
  white:  '#FFFFFF',
  canvas: '#FAF8F2',
  gray400:'#9CA3AF',
  gray500:'#6B7280',
  gray700:'#374151',
  border: '#E5E7EB',
  textPrimary: '#111827',
  midnight: '#0F1117',
  royal: '#F7D000',
};

interface Props { user?: AuthUser | null }

export function UnauthorizedPage({ user }: Props) {
  const { lang } = useLang();
  const navigate  = useNavigate();
  const E = lang === 'en';

  return (
    <div
      style={{
        minHeight:       '100vh',
        backgroundColor: C.canvas,
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        fontFamily:      '"Noto Sans", sans-serif',
        padding:         '24px',
      }}
    >
      <div
        style={{
          backgroundColor: C.white,
          borderRadius:    '16px',
          border:          `1px solid ${C.border}`,
          padding:         '48px 40px',
          maxWidth:        '480px',
          width:           '100%',
          textAlign:       'center',
          boxShadow:       '0 4px 24px rgba(0,0,0,0.08)',
        }}
      >
        {/* Lock icon in royal yellow */}
        <div
          style={{
            width:           '80px',
            height:          '80px',
            borderRadius:    '50%',
            backgroundColor: C.yellow,
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            margin:          '0 auto 24px',
            fontSize:        '36px',
          }}
        >
          🔒
        </div>

        {/* Error code */}
        <p style={{ fontSize: '13px', fontWeight: 600, color: C.gray400, letterSpacing: '0.1em', marginBottom: '8px', textTransform: 'uppercase' }}>
          {E ? 'Access Denied — 403' : 'Akses Ditolak — 403'}
        </p>

        {/* Heading */}
        <h1 style={{ fontFamily:'"Noto Serif", Georgia, serif', fontSize: '24px', fontWeight: 700, color: C.black, marginBottom: '16px', lineHeight: 1.3 }}>
          {E
            ? 'You do not have permission to access this page.'
            : 'Anda tidak mempunyai kebenaran untuk mengakses halaman ini.'}
        </h1>

        {/* Subtext */}
        <p style={{ fontSize: '14px', color: C.gray500, marginBottom: '32px', lineHeight: 1.6 }}>
          {E
            ? 'This page is restricted to specific roles. If you believe this is an error, please contact your system administrator.'
            : 'Halaman ini hanya boleh diakses oleh peranan tertentu. Jika anda rasa ini adalah ralat, sila hubungi pentadbir sistem anda.'}
        </p>

        {/* Divider */}
        <div style={{ height: '1px', backgroundColor: C.border, marginBottom: '24px' }} />

        {/* Role info */}
        {user && (
          <p style={{ fontSize: '12px', color: C.gray400, marginBottom: '24px' }}>
            {E ? 'You are signed in as' : 'Anda log masuk sebagai'}{' '}
            <strong style={{ color: C.gray700 }}>{user.email}</strong>
            {' · '}
            <span style={{ textTransform: 'capitalize' }}>
              {user.roles.map((r) => r.role.replace('_', ' ')).join(', ')}
            </span>
          </p>
        )}

        {/* Back button */}
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: C.yellow,
            color:           C.black,
            border:          'none',
            borderRadius:    '8px',
            padding:         '12px 28px',
            fontSize:        '14px',
            fontWeight:      700,
            cursor:          'pointer',
            width:           '100%',
            fontFamily:      '"Inter", sans-serif',
          }}
        >
          {E ? '← Back to Dashboard' : '← Kembali ke Papan Pemuka'}
        </button>
      </div>
    </div>
  );
}
